export default class {
    constructor ($translate, MomentService) {
        this.$translate = $translate;
        this.MomentService = MomentService;
    }

    /**
     * Returns period label for selectbox
     * @param period
     */
    licencePeriodTranslation (period) {
        const params = {
            acquiringDate: this.MomentService.formatDate(period.acquiringDate),
            enteringDate: this.MomentService.formatDate(period.enteringDate)
        };
        return this.$translate.instant('licence.Acquiring deadline: {acquiringDate}, Entering deadline: {enteringDate}', params);
    }

    /**
     * This function helps to collect all the periodids to be sent as param
     * @param licences
     * @returns {[]}
     */
    getLicencePeriodIdsAsArray (licences) {
        const result = [];
        licences.forEach((licence) => {
            licence.licencePeriods.forEach((licencePeriod) => {
                if (result.indexOf(licencePeriod.id) < 0) {
                    result.push(licencePeriod.id);
                }
            });
        });
        return result;
    }

    /**
     * This function helps to get multiselect options for licence periods
     * @param licences
     * @returns {[]}
     */
    getLicencePeriodMultiselectOptions (licences) {
        const result = [];
        licences.forEach((licence) => {
            licence.licencePeriods.forEach((licencePeriod) => {
                if (result.indexOf({ value: licencePeriod.id, label: this.licencePeriodTranslation(licencePeriod) }) < 0) {
                    result.push({
                        value: licencePeriod.id,
                        label: this.licencePeriodTranslation(licencePeriod),
                        licenceName: licence.name
                    });
                }
            });
        });
        return result;
    }

    /**
     * Overview helper
     * @param licences
     * @param licencePeriodId
     */
    getLicencePeriodOverviewText (licences, licencePeriodId) {
        let result = '';
        licences.forEach((licence) => {
            licence.licencePeriods.forEach((licencePeriod) => {
                if (licencePeriod.id === parseInt(licencePeriodId, 10)) {
                    result = this.licencePeriodTranslation(licencePeriod);
                }
            });
        });
        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/licence/index.js